<template>
  <div>
    <h1>Select 选择器</h1>
    <p class="page-desc">
      使用模拟的增强下拉选择器来代替浏览器原生的选择器。
    </p>

    <k-row gutter="16">
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer
          title="基本用法"
          :code="JCYF"
          desc="可以使用 v-model 实现数据的双向绑定。"
        >
          <p>{{ value }}</p>
          <p>
            <k-select v-model="value" style="width:200px;margin-bottom:16px;">
              <k-option
                v-for="item in bookList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </k-option>
            </k-select>
            <k-divider type="vertical" />
            <k-select
              v-model="value"
              style="width:200px;margin-bottom:16px;"
            ></k-select>
          </p>
        </demo-viewer>

        <demo-viewer
          title="事件"
          :code="SJ"
          desc="可以使用 v-model 实现数据的双向绑定。"
        >
          <p>
            <k-select
              v-model="value"
              @on-change="handleChange"
              style="width:200px;"
            >
              <k-option
                v-for="item in bookList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </k-option>
            </k-select>
          </p>
        </demo-viewer>
      </k-col>
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer
          title="禁用选择器"
          :code="JYXZQ"
          desc="通过给Select设置属性disabled禁用整个选择器。"
        >
          <p>
            <k-select disabled style="width:200px;"></k-select>
          </p>
        </demo-viewer>

        <demo-viewer
          title="禁用选项"
          :code="JYXX"
          desc="通过给Option设置属性disabled可以禁用当前项。"
        >
          <p>
            <k-select style="width:200px;">
              <k-option
                v-for="item in bookList"
                :key="item.value"
                :value="item.value"
                :disabled="item.value == 'ISBN: 9787513910408'"
                >{{ item.label }}</k-option
              >
            </k-select>
          </p>
        </demo-viewer>

        <demo-viewer
          title="圆角"
          :code="YJ"
          desc="circle 属性将使选择器设置为大圆角。"
        >
          <p>
            <k-select
              v-model="value"
              circle
              style="width:200px;margin-bottom:16px;"
            >
              <k-option
                v-for="item in bookList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </k-option>
            </k-select>
          </p>
        </demo-viewer>
      </k-col>
    </k-row>

    <table class="doc-table">
      <caption>
        <h3>属性 Select props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>value</td>
          <td>指定当前是否选中，可以使用 v-model 双向绑定数据</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>disabled</td>
          <td>禁用开关</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>circle</td>
          <td>将使选择器设置为大圆角</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>

    <table class="doc-table">
      <caption>
        <h3>选项属性 Option props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>value</td>
          <td>选项值，默认根据此属性值进行筛选，必填</td>
          <td>String | Number</td>
          <td>无</td>
        </tr>
        <tr>
          <td>disabled</td>
          <td>是否禁用当前项</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>

    <table class="doc-table">
      <caption>
        <h3>事件 events</h3>
      </caption>
      <thead>
        <tr>
          <th>事件名</th>
          <th>说明</th>
          <th>返回值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>on-change</td>
          <td>选择时触发</td>
          <td>选中项的value</td>
        </tr>
        <tr>
          <td>on-select-selected</td>
          <td>选择时触发</td>
          <td>选中项的对象，{label:"",value:""}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: "",
      bookList: [
        {
          value: "ISBN: 9787536692930",
          label: "《三体》"
        },
        {
          value: "ISBN: 9787108030429",
          label: "《文心》"
        },
        {
          value: "ISBN: 9787513910408",
          label: "《大众哲学》"
        },
        {
          value: "ISBN: 9787533935498",
          label: "《我所理解的生活》"
        },
        {
          value: "ISBN: 9787115470669",
          label: "《CSS世界》"
        },
        {
          value: "ISBN: 9787220101304",
          label: "《认识电影》"
        }
      ],
      JCYF:
        `
  <template>
    <k-select v-model="value" style="width:200px;">
      <k-option
        v-for="item in bookList"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </k-option>
    </k-select>
  </template>
  <script>
    export default {
      data () {
        return {
          value: "",
          bookList: [
            {
              value: "ISBN: 9787536692930",
              label: "《三体》"
            },
            {
              value: "ISBN: 9787108030429",
              label: "《文心》"
            },
            {
              value: "ISBN: 9787513910408",
              label: "《大众哲学》"
            },
            {
              value: "ISBN: 9787533935498",
              label: "《我所理解的生活》"
            },
            {
              value: "ISBN: 9787115470669",
              label: "《CSS世界》"
            },
            {
              value: "ISBN: 9787220101304",
              label: "《认识电影》"
            }
          ]
        }  
      }
    }
  </` +
        `script>
  `,
      SJ:
        `
  <template>
    <k-select v-model="value" @on-change="handleChange" style="width:200px;">
      <k-option
        v-for="item in bookList"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </k-option>
    </k-select>
  </template>
  <script>
    export default {
      data () {
        return {
          value: "",
          bookList: [
            {
              value: "ISBN: 9787536692930",
              label: "《三体》"
            },
            {
              value: "ISBN: 9787108030429",
              label: "《文心》"
            },
            {
              value: "ISBN: 9787513910408",
              label: "《大众哲学》"
            },
            {
              value: "ISBN: 9787533935498",
              label: "《我所理解的生活》"
            },
            {
              value: "ISBN: 9787115470669",
              label: "《CSS世界》"
            },
            {
              value: "ISBN: 9787220101304",
              label: "《认识电影》"
            }
          ]
        }  
      },
      methods: {
        handleChange(value) {
          this.$Message("Changed! value：" + value);
        }
      }
    }
  </` +
        `script>
  `,
      JYXZQ: `
  <template>
    <k-select disabled></k-select>
  </template>
      `,
      JYXX: `
  <template>
    <k-select v-model="value" style="width:200px;">
      <k-option
        v-for="item in bookList"
        :key="item.value"
        :value="item.value"
        :disabled="item.value == 'ISBN: 9787513910408'"
      >
        {{ item.label }}
      </k-option>
    </k-select>
  </template>
      `,
      YJ: `
  <template>
    <k-select circle></k-select>
  </template>
  `
    };
  },
  methods: {
    handleChange(value) {
      console.log("on-change", value);
      this.$Message("Changed! value：" + value);
    },
    handleSelected(selection) {
      console.log("on-select-selected", selection);
    }
  }
};
</script>
